import { useEffect, useState } from "react";
import { API, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "@/components/ui/sonner";
import { WeekScheduleEditor } from "@/components/WeekScheduleEditor";

export default function Availability() {
  const [days, setDays] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    API.get("/availability").then((r) => setDays(r.data.days)).catch((e) => toast.error(formatApiError(e)));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await API.put("/availability", { days });
      toast.success("Horaires enregistrés");
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-2xl space-y-4" data-testid="availability-page">
      <div>
        <h1 className="font-display text-2xl font-bold text-slate-900">Disponibilités</h1>
        <p className="mt-1 text-sm text-slate-500">
          Horaires hebdomadaires de l'entreprise. Plusieurs plages par jour permettent de gérer la pause déjeuner.
          Les exceptions et jours fériés sont prioritaires sur ces horaires.
        </p>
      </div>
      {!days ? (
        <p className="text-sm text-slate-400">Chargement...</p>
      ) : (
        <>
          <WeekScheduleEditor value={days} onChange={setDays} testidPrefix="avail" />
          <Button onClick={save} disabled={saving} className="w-full sm:w-auto" data-testid="availability-save">
            {saving ? "Enregistrement..." : "Enregistrer les horaires"}
          </Button>
        </>
      )}
    </div>
  );
}
